var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleDrive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "google-drive",
    enableBackground: "new 0 0 141.7 141.7",
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "M25.8,104.7l4.7,8.1c1,1.7,2.4,3,4,4l16.7-29H17.8c0,1.9,0.5,3.8,1.5,5.5L25.8,104.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M107.2,116.8c1.6-1,3-2.3,4-4l1.9-3.3l9.3-16.1c1-1.7,1.5-3.6,1.5-5.5H90.5l7.1,14L107.2,116.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00832d",
    d: "M70.9,53.8l16.7-29c-1.6-1-3.5-1.5-5.5-1.5H59.6c-1.9,0-3.8,0.5-5.5,1.5L70.9,53.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2684fc",
    d: "M90.5,87.9H51.2l-16.7,29c1.6,1,3.5,1.5,5.5,1.5h61.8c1.9,0,3.8-0.5,5.5-1.5L90.5,87.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "M107.1,55.7L91.6,28.9c-1-1.7-2.4-3-4-4l-16.7,29l19.6,34.1h33.4c0-1.9-0.5-3.8-1.5-5.5L107.1,55.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "M19.2,82.4c-1,1.7-1.5,3.6-1.5,5.5h33.4l19.6-34.1l-16.7-29c-1.6,1-3,2.3-4,4L34.6,55.7L19.2,82.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/google-drive.629cdb47709f63698b7f707dac796f0f.svg";
export { ForwardRef as ReactComponent };